<div class="relative">
  <input
    type="email"
    [formControl]="control()"
    [placeholder]="placeholder()"
    [class.border-th-red]="control().invalid && showErrors()"
    [class.border-th-dark-blue]="!(control().invalid && showErrors())"
    class="peer w-full px-4 py-3 border-2 rounded-lg text-th-dark-blue text-[16px] font-medium focus:outline-none focus:border-th-blue-highlight-2"
  />
  <label
    [class.text-th-red]="control().invalid && showErrors()"
    class="absolute left-3 -top-2.5 bg-white px-1 text-th-dark-blue font-medium transition-all pointer-events-none peer-placeholder-shown:text-[16px] peer-placeholder-shown:text-th-blue-placeholder peer-placeholder-shown:top-3 peer-placeholder-shown:left-4 peer-focus:-top-2.5 peer-focus:left-3 peer-focus:text-[12px] peer-focus:text-th-dark-blue peer-not-placeholder-shown:text-[12px]"
  >
    {{ label() }}
  </label>
</div>

@if ((control().hasError('required') || control().hasError('invalidEmail')) && showErrors()) {
  <p class="text-th-red font-semibold text-[12px] mt-1 px-0.5">
    Introduce un correo electrónico válido
  </p>
}
